import {FormattableString} from "./FormattableString";

export default class UserError extends Error {
	title: FormattableString;
	detail?: FormattableString;
	errors?: FormattableString[];
	footer?: FormattableString;

	constructor(title: FormattableString, detail?: FormattableString, errors?: FormattableString[], footer?: FormattableString) {
		super(title.text);

		this.title = title;
		this.detail = detail;
		this.errors = errors;
		this.footer = footer;
	}
}
